import { ApiRuntimeMode } from '@core/runtime/api-runtime-mode';

import type { AppEnvironment } from './app-environment.model';

/**
 * Build/serve `mock`: respostas `/api/**` vêm da camada mock (handlers ou 501);
 * nenhuma requisição para `/api/**` faz fallback para o backend.
 */
export const environment: AppEnvironment = {
  production: false,
  apiRuntimeMode: ApiRuntimeMode.Mock,
  //themeClass: 'theme-blue-slate',
  themeClass: 'theme-honey-brick',
  //themeClass: 'theme-ruby-honey',
  //themeClass: 'theme-red-garnet',
  publicBroker: {
    creci: '59225-F',
    email: 'fonsecaimoveis@hotmail.com',
    name: 'Antonio Carlos A. da Fonseca',
    whatsappDigits: '5519992554324',
  },
};
